mapboxgl.accessToken =
  "pk.eyJ1IjoidGhlaGF0Y2hlcnkiLCJhIjoiY2w3czF4MzdyMGwwaDNvbnYza3E1ZWM1MCJ9.6ayNDmPgPlnLMFQJsq7XMg";

const map = new mapboxgl.Map({
  container: "map", // container ID
  style: "mapbox://styles/thehatchery/clmuw1ls705mf01p93ta1fqmb", // style URL
  center: [-119.594, 49.499], // starting position [lng, lat]
  zoom: 17, // starting zoom
});

map.scrollZoom.disable();
map.addControl(new mapboxgl.NavigationControl());
